import { Link } from 'react-router-dom';

interface ArticleCardProps {
  slug: string;
  title: string;
  excerpt: string;
  category: string;
  categoryName: string;
  publishDate: string;
  readTime: number;
  tags: string[];
  imageUrl: string;
}

export default function ArticleCard({
  slug,
  title,
  excerpt,
  category,
  categoryName,
  publishDate,
  readTime,
  tags,
  imageUrl,
}: ArticleCardProps) {
  return (
    <article className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden hover:border-primary-200 transition-all duration-300">
      <Link to={`/article/${slug}`} className="block">
        <div className="aspect-[16/9] overflow-hidden">
          <img
            src={imageUrl}
            alt={title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
        </div>
      </Link>
      <div className="p-5">
        <div className="flex items-center gap-3 mb-3">
          <Link
            to={`/category/${category}`}
            className="text-xs font-medium px-2.5 py-1 rounded-full bg-accent-100 text-accent-800 hover:bg-accent-200 transition-colors whitespace-nowrap"
          >
            {categoryName}
          </Link>
          <span className="text-xs text-foreground-400">{publishDate}</span>
          <span className="text-xs text-foreground-400">{readTime}分钟阅读</span>
        </div>
        <Link to={`/article/${slug}`}>
          <h3 className="text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors line-clamp-2 font-heading">
            {title}
          </h3>
        </Link>
        <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-3">
          {excerpt}
        </p>
        <div className="flex flex-wrap gap-1.5">
          {tags.slice(0, 3).map((tag) => (
            <span
              key={tag}
              className="text-xs px-2 py-0.5 rounded bg-secondary-100 text-secondary-700 whitespace-nowrap"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </article>
  );
}